import React from 'react'
import { IconBaseProps, IconType } from "react-icons/lib";

interface propsType {
    icon: IconType,
    props?: IconBaseProps
}

export default function GetIcon({icon, props}:propsType) {
    const Icon = icon;
    return <Icon {...props}/>;
}